// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bloc-input {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.bloc-input .g-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #2c2b4a;
}
.bloc-input .bloc-input {
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: white;
  padding: 10px 15px;
  position: relative;
  /* TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version. */
}
.bloc-input .bloc-input mat-progress-bar {
  position: absolute;
  top: 0;
  left: 1%;
  width: 98%;
  height: 1px;
}
.bloc-input .bloc-input .placeholder {
  position: absolute;
  z-index: 0;
  left: 43px;
  color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.bloc-input .bloc-input .placeholder.top {
  z-index: 2;
  top: -15px;
  background: white;
  padding: 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}
.bloc-input .bloc-input input {
  z-index: 1;
  width: 80%;
}
.bloc-input .bloc-input .icon {
  text-align: center;
  flex: 1;
  position: relative;
  max-width: 12px;
  margin-right: 15px;
}
.bloc-input .bloc-input .icon ::ng-deep mat-icon {
  width: 12px;
  position: absolute;
  font-size: 1.1rem;
  bottom: 0;
  left: calc(50% - 9px);
  top: calc(50% - 9px);
}
.bloc-input .bloc-input.small {
  margin: 0;
  border: 2px solid #104a64;
  border-radius: 22px;
  padding-left: 15px;
}
.bloc-input .bloc-input.primary {
  border: 2px solid #104a64;
  border-radius: 22px;
}
.bloc-input .bloc-input.primary:focus-within {
  border-color: #104a64;
}
.bloc-input .bloc-input.primary:focus-within .icon ::ng-deep {
  color: #104a64;
}
.bloc-input .bloc-input.primary .icon ::ng-deep {
  color: #5620e4;
}
.bloc-input .bloc-input.simple-input {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.bloc-input .bloc-input.simple-input:hover {
  border-color: #2c2b4a;
}
.bloc-input .bloc-input .g-input {
  background-color: transparent;
  flex: 9;
  border-radius: 22px;
  border: none;
  outline: none;
  /* Change the white to any color */
}
.bloc-input .bloc-input .g-input:-webkit-autofill, .bloc-input .bloc-input .g-input:-webkit-autofill:hover, .bloc-input .bloc-input .g-input:-webkit-autofill:focus, .bloc-input .bloc-input .g-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.bloc-input .bloc-input.error {
  border-color: #ff3636 !important;
}
.bloc-input .bloc-input.error mat-icon {
  color: #ff3636;
}
.bloc-input .bloc-input.valid {
  border-color: rgb(31, 163, 31) !important;
}
.bloc-input .bloc-input.valid mat-icon {
  color: rgb(31, 163, 31);
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/shared/components/g-autocomplete/g-autocomplete.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AADJ;AAGI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EAEI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mIAAA;AAHR;AAIQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,UAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAHhB;AAOQ;EACI,UAAA;EACA,UAAA;AALZ;AAQQ;EACI,kBAAA;EACA,OAAA;EACA,kBAAA;EAEA,eADa;EAEb,kBAAA;AAPZ;AAUgB;EACI,WANK;EAOL,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;EACA,oBAAA;AARpB;AAaQ;EACI,SAAA;EACA,yBAAA;EACA,mBA/DU;EAgEV,kBAAA;AAXZ;AAcQ;EACI,yBAAA;EACA,mBArEU;AAyDtB;AAcY;EACI,qBCrFA;ADyEhB;AAeoB;EACI,cCzFR;AD4EhB;AAmBgB;EACI,cAAA;AAjBpB;AAsBQ;EACI,oCAAA;EACA,kBAAA;AApBZ;AAsBY;EACI,qBAAA;AApBhB;AAwBQ;EACI,6BAAA;EACA,OAAA;EACA,mBApGU;EAqGV,YAAA;EACA,aAAA;EAEA,kCAAA;AAvBZ;AAwBY;EAII,qDAAA;AAzBhB;AA6BQ;EAEI,gCAAA;AA5BZ;AA8BY;EACI,cAJU;AAxB1B;AAgCQ;EAEI,yCAAA;AA/BZ;AAiCY;EACI,uBAJU;AA3B1B;;AAoCA;EACI,kCAAA;AAjCJ","sourcesContent":["@import \"src/styles/_variables.scss\";\r\n\r\n.bloc-input {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: left;\r\n\r\n    .g-label {\r\n        font-weight: 500;\r\n        font-size: 12px;\r\n        line-height: 16px;\r\n        color: #2c2b4a;\r\n    }\r\n\r\n    .bloc-input {\r\n        $size-border: 22px;\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        background-color: white;\r\n        padding: 10px 15px;\r\n        position: relative;\r\n        /* TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version. */\r\n        mat-progress-bar {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 1%;\r\n            width: 98%;\r\n            height: 1px;\r\n        }\r\n\r\n        .placeholder {\r\n            position: absolute;\r\n            z-index: 0;\r\n            left: 43px;\r\n            color: rgba(0, 0, 0, 0.5);\r\n            border-radius: 10px;\r\n\r\n            &.top {\r\n                z-index: 2;\r\n                top: -15px;\r\n                background: white;\r\n                padding: 0 5px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n                max-width: 80%;\r\n            }\r\n        }\r\n\r\n        input {\r\n            z-index: 1;\r\n            width: 80%;\r\n        }\r\n\r\n        .icon {\r\n            text-align: center;\r\n            flex: 1;\r\n            position: relative;\r\n            $width-icon: 12px;\r\n            max-width: $width-icon;\r\n            margin-right: 15px;\r\n\r\n            ::ng-deep {\r\n                mat-icon {\r\n                    width: $width-icon;\r\n                    position: absolute;\r\n                    font-size: 1.1rem;\r\n                    bottom: 0;\r\n                    left: calc(50% - 9px);\r\n                    top: calc(50% - 9px);\r\n                }\r\n            }\r\n        }\r\n\r\n        &.small {\r\n            margin: 0;\r\n            border: 2px solid $primary-color;\r\n            border-radius: $size-border;\r\n            padding-left: 15px;\r\n        }\r\n\r\n        &.primary {\r\n            border: 2px solid $primary-color;\r\n            border-radius: $size-border;\r\n\r\n            &:focus-within {\r\n                border-color: $primary-color;\r\n\r\n                .icon {\r\n                    ::ng-deep {\r\n                        color: $primary-color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .icon {\r\n                ::ng-deep {\r\n                    color: #5620e4;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.simple-input {\r\n            border: 1px solid rgba(0, 0, 0, 0.2);\r\n            border-radius: 5px;\r\n\r\n            &:hover {\r\n                border-color: #2c2b4a;\r\n            }\r\n        }\r\n\r\n        .g-input {\r\n            background-color: transparent;\r\n            flex: 9;\r\n            border-radius: $size-border;\r\n            border: none;\r\n            outline: none;\r\n\r\n            /* Change the white to any color */\r\n            &:-webkit-autofill,\r\n            &:-webkit-autofill:hover,\r\n            &:-webkit-autofill:focus,\r\n            &:-webkit-autofill:active {\r\n                -webkit-box-shadow: 0 0 0 30px white inset !important;\r\n            }\r\n        }\r\n\r\n        &.error {\r\n            $color-error: #ff3636;\r\n            border-color: $color-error !important;\r\n\r\n            mat-icon {\r\n                color: $color-error;\r\n            }\r\n        }\r\n\r\n        &.valid {\r\n            $color-valid: rgb(31, 163, 31);\r\n            border-color: $color-valid !important;\r\n\r\n            mat-icon {\r\n                color: $color-valid;\r\n            }\r\n        }\r\n    }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n    background-color: white !important;\r\n  }","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
